<template>
  <div class="frosted-card">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FrostedCard'
}
</script>

<style scoped>
.frosted-card {
  /* 毛玻璃核心样式 */
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px); /* Safari 兼容 */

  /* 半透明白色背景（可根据背景色调整） */
  background: rgba(255, 255, 255, 0.65);

  /* 圆角 & 内边距 */
  border-radius: 16px;
  padding: 16px;

  /* 边框增强层次感（可选） */
  border: 1px solid rgba(255, 255, 255, 0.3);

  /* 阴影提升立体感 */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

  /* 防止内容溢出 */
  overflow: hidden;

  /* 确保在深色背景下也可见 */
  color: #333;
}
</style>